import React, { useEffect, useState } from "react";
import api from "../lib/api";
import { PageHeader, TableWrap, Th, Td, Loading, EmptyState, Badge } from "../components/shared";
import { formatDateTime } from "../lib/format";
import { Button } from "../components/ui/button";

const ACTION_CLS = { create: "bg-emerald-50 text-emerald-700 border-emerald-200", update: "bg-blue-50 text-blue-700 border-blue-200", reverse: "bg-rose-50 text-rose-700 border-rose-200", deactivate: "bg-slate-100 text-slate-600 border-slate-200" };

export default function Audit() {
  const [items, setItems] = useState([]);
  const [total, setTotal] = useState(0);
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    setLoading(true);
    api.get(`/audit?page=${page}&limit=50`).then((r) => { setItems(r.data.items); setTotal(r.data.total); }).finally(() => setLoading(false));
  }, [page]);
  return (
    <div>
      <PageHeader title="Audit Logs" subtitle={`${total} recorded actions · permanent history`} />
      {loading ? <Loading /> : items.length === 0 ? <EmptyState title="No audit entries yet" /> : (
        <>
          <TableWrap><thead><tr><Th>Date / Time</Th><Th>User</Th><Th>Action</Th><Th>Entity</Th><Th>Details</Th><Th>Reason</Th></tr></thead>
            <tbody>{items.map((a) => (
              <tr key={a.id}><Td>{formatDateTime(a.created_at)}</Td><Td className="font-medium">{a.user_name}</Td>
                <Td><Badge cls={ACTION_CLS[a.action] || "bg-slate-100 text-slate-600 border-slate-200"}>{a.action}</Badge></Td>
                <Td>{a.entity}</Td>
                <Td className="max-w-[280px] truncate text-[11px] font-mono text-slate-500">{a.new_value ? JSON.stringify(a.new_value) : "-"}</Td>
                <Td>{a.reason || "-"}</Td></tr>
            ))}</tbody></TableWrap>
          {total > 50 && <div className="flex justify-end gap-2 mt-3">
            <Button size="sm" variant="outline" disabled={page === 1} onClick={() => setPage((p) => p - 1)}>Previous</Button>
            <Button size="sm" variant="outline" disabled={page >= Math.ceil(total / 50)} onClick={() => setPage((p) => p + 1)}>Next</Button></div>}
        </>
      )}
    </div>
  );
}
